import Vue from 'vue'
import Vuex from 'vuex'
import { truncate } from 'fs';

Vue.use(Vuex)

export const store = new Vuex.Store({
         state: {
           loadedPortfolio: [
             {
               id: 1,
               title: "PPID - DPR",
               image: "port1.png",
               imageFull: "PPID.png",
               link: "http://sandbox.dot.co.id/ppid-dpr",
               linkVisible: true,
               desc:
                 "At DOT INDONESIA, I'm entered the PPID - DPR team as a Front-End Developer Intern and did on the PPID Front - End part. In the PPID I'm used Bootstrap 4 and some JQuery plugins while carrying Responsive Design so that it can be accessed on the device anywhere."
             },
             {
               id: 2,
               title: "PUSDIKLAT - DPR",
               image: "port2.png",
               imageFull: "PUSDIKLAT.png",
               link: null,
               linkVisible: false,
               desc:
                 "At DOT INDONESIA I'm entered the PUSDIKLAT - DPR team as a Front - End Developer Intern and did on the SMI Front - End part. at PUSDIKLAT I'm used Bootstrap 3 and some Javascript framework like JQuery and Datatables and carrying Responsive Design for more experience."
             },
             {
               id: 3,
               title: "SMI - MONITORING",
               image: "port3.png",
               imageFull: "SMI.png",
               link: null,
               linkVisible: false,
               desc:
                 "At DOT INDONESIA I'm entered the SMI - MONITORING team as a Front - End Developer Intern and did on the SMI Front - End part. At SMI I'm used Bootstrap 4,JQuery and other JS frameworks such as moment.js, dataTables and others to make great experience while used this website."
             },
             {
               id: 4,
               title: "ETAPAS",
               image: "port5.png",
               link: "https://etapas.id",
               imageFull: "ETAPAS.png",
               linkVisible: true,
               desc:
                 "At DOT INDONESIA I'm entered the ETAPAS team as a Front - End Developer Intern and did on the ETAPAS Front - End part. at ETAPAS I'm used Bootstrap 3 and JQuery for primary framework and Responsive Design from Designer for better experience in any devices."
             },
             {
               id: 5,
               title: "MY WEBSITE",
               image: "port6.png",
               imageFull: "MYPORT.png",
               link: "https://axelandrian.me",
               linkVisible: true,
               desc:
                 "I'm used Bulma and Vue.JS for Primary Framework in my website and used SPA (Single Page Application) for faster load. Responsive Design for better experience in multiple devices. For Design, I'm got inspiration from new Google Design : Material Design 2.0"
             },
             {
               id: 6,
               title: "MUSLIMNESIA",
               image: "port7.png",
               imageFull: "MUSLIMNESIA.png",
               link: "http://muslimnesia.co.id",
               linkVisible: true,
               desc:
                 "At DOT INDONESIA I'm entered the MUSLIMNESIA team as a Front - End Developer Intern and did on the MUSLIMNESIA Front - End part. at MUSLIMNESIA I'm used Bootstrap 3 and JQuery for primary framework and Responsive Design from Designer for better experience in any devices.Use same UI design with ETAPAS"
             }
           ],
           loadedSkills: [
             {
               id: 1,
               image: "skills.svg",
               title: "Skills",
               lists: [
                 "PWA",
                 "PHP",
                 "CSS3",
                 "HTML5",
                 "Javascript",
                 "Wordpress Development",
                 "Responsive Web Design"
               ]
             },
             {
               id: 2,
               image: "new-file.svg",
               title: "Tools",
               lists: [
                 "VSCode",
                 "Github",
                 "Gitlab",
                 "Terminal",
                 "GitKraken",
                 "Koala Compiler",
                 "Paper & Pencil"
               ]
             },
             {
               id: 3,
               image: "framework.svg",
               title: "Framework",
               lists: [
                 "SASS",
                 "Bulma",
                 "VueJS",
                 "JQuery",
                 "Webpack",
                 "Bootstrap",
                 "AngularJS"
               ]
             }
           ],
           loadedFeatures: [
             {
               id: 1,
               image: "speedometer.svg",
               title: "FAST",
               desc: "Optimizing page for user comfortable"
             },
             {
               id: 2,
               image: "clean-code.svg",
               title: "CLEAN",
               desc: "Make website clean code and beautiful"
             },
             {
               id: 3,
               image: "devices.svg",
               title: "RESPONSIVE",
               desc: "Website work for phone, tablet, and desktop."
             },
             {
               id: 4,
               image: "domain-registration.svg",
               title: "MODERN",
               desc: "Preference for easy to use and user friendly"
             }
           ],
           medLink: [
             {
               id: 1,
               link: "https://www.facebook.com/Exzell",
               classIcon: "fab fa-facebook-f"
             },
             {
               id: 2,
               link: "https://twitter.com/exzword_",
               classIcon: "fab fa-twitter"
             },
             {
               id: 3,
               link: "https://www.instagram.com/exzword_/",
               classIcon: "fab fa-instagram"
             },
             {
               id: 4,
               link: "https://medium.com/@axelandrian001",
               classIcon: "fab fa-medium-m"
             },
             {
               id: 5,
               link: "https://www.linkedin.com/in/axelandrian/",
               classIcon: "fab fa-linkedin-in"
             },
             {
               id: 6,
               link: "mailto:axelandrian001@gmail.com",
               classIcon: "far fa-envelope"
             }
           ]
         }
       });